import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { Body1, EntradaForm, H6, Icone, Tab } from "../../../components";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import useFetch from "../../../hooks/use-fetch";
import * as yup from "yup";
import { ToastErro } from "../../../utils/utilitarios";
import { formatarData, formatarDataHora } from "../../../utils/datas";
import { getLabelStatusCashback, getStatusCashback } from "./cashback-utils";
import { Utilitarios } from "../../../utils";
import { green } from "@mui/material/colors";

const STR = {
  tab1: "VALIDAR VOUCHER",
  tab2: "PESQUISAR VOUCHER",
  tab1Description:
    "Informe no campo abaixo o voucher para validação, assim como o cv em que será aplicado o voucher",
  tab2Description:
    "Digite o CPF do cliente, caso tenha um voucher válido, será exibido abaixo",
  cashbackInfoCvSale: "Cv da venda",
  cashbackInfoDataSend: "Data de envio",
  cashbackInfoDataDeadLine: "Válido até",
  cashbackInfoStore: "Loja",
  cashbackInfoNameClient: "Nome do cliente",
  cashbackInfoStatus: "Status",
  cashbackInfoCellPhone: "Celular",
  cashbackInfoValueVoucher: "Valor do voucher",
  cashbackInfoVoucher: "Voucher (clique nele para copiar)",
  cashbackInfoVoucherTitle: "Clique para copiar o codigo",
  cashbackInfoVoucherCopied: "Voucher copiado para área de transferência",
  cashbackInfoSeller: "Vendedor(a)",
  labelCpf: "CPF",
  placeholderCPF: "Digite o CPF",
  errorCPF: "Formato aceito 000.000.000-00",
  labelClear: "PESQUISAR NOVAMENTE",
  labelVoucher: "Voucher",
  labelCvUsed: "Cv utilizado",
  placeholderVoucher: "Digite o voucher",
  errorVoucher: "Formato aceito xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
  placeholderCvUsed: "Digite o cv utilizado com o voucher",
  errorCvUsed: "Formato aceito xxxxxxx-xxxx",
};

const KEYS = {
  cpf: "cgc",
  voucher: "voucher",
  cvUsed: "cv_utilizado",
};

function CashbackValidateSearch() {
  const headers = [
    { label: STR.tab1, icon: "Verified" },
    { label: STR.tab2, icon: "Search" },
  ].map((ele, idx) => (
    <Stack direction="row" gap={1.5} alignItems="center" key={idx}>
      <Icone icone={ele.icon} />
      <Body1>{ele.label}</Body1>
    </Stack>
  ));
  const body = [<CashbackValidate />, <CashbackSearch />];

  return <Tab cabe={headers} corpo={body} />;
}

const CashbackValidate = () => {
  const { data, error, wait, setFetch } = useFetch(
    "/cashback_api",
    "PUT",
    "JSON"
  );
  //
  useEffect(() => {
    if (error) {
      ToastErro(error);
    }
  }, [error]);
  //
  useEffect(() => {
    if (data) {
      toast.dark(data.sucesso, {
        type: "success",
      });
    }
  }, [data]);
  //
  const schema = [
    {
      type: "text",
      name: KEYS.voucher,
      label: STR.labelVoucher,
      placeholder: STR.placeholderVoucher,
      mask: [
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        "-",
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        "-",
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        "-",
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        "-",
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
      ],
      required: true,
    },
    {
      type: "text",
      name: KEYS.cvUsed,
      label: STR.labelCvUsed,
      placeholder: STR.placeholderCvUsed,
      mask: [
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
    },
  ];
  const schemaMessageError = {
    [KEYS.voucher]: STR.errorVoucher,
    [KEYS.cvUsed]: STR.errorCvUsed,
  };

  const schemaValidator = yup.object().shape({
    [KEYS.voucher]: yup
      .string()
      .matches(
        /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/
      )
      .required(),
    [KEYS.cvUsed]: yup
      .string()
      .matches(/^[a-fA-F0-9]{7}-\d{4}$/)
      .required(),
  });
  //
  const onSubmit = useCallback(
    (val) => {
      setFetch({
        voucher: val.voucher,
        cv_utilizado: val.cv_utilizado,
      });
    },
    [setFetch]
  );

  return (
    <Stack sx={{ mt: 1 }}>
      <H6>{STR.tab1}</H6>
      <Body1 align="center">{STR.tab1Description}</Body1>
      <EntradaForm
        schema={schema}
        schemaValidator={schemaValidator}
        schemaMessageError={schemaMessageError}
        onSubmit={onSubmit}
        wait={wait}
      />
    </Stack>
  );
};

const CashbackSearch = () => {
  const { data, clearData, error, wait, setFetch } = useFetch(
    "/cashback_api/consulta",
    "GET"
  );
  //
  useEffect(() => {
    if (error) {
      ToastErro(error);
    }
  }, [error]);
  //
  const schema = [
    {
      type: "text",
      name: KEYS.cpf,
      label: STR.labelCpf,
      placeholder: STR.placeholderCPF,
      mask: [
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
      ],
      required: true,
    },
  ];
  //
  const schemaMessageError = {
    [KEYS.cpf]: STR.errorCPF,
  };
  const schemaValidator = yup.object().shape({
    [KEYS.cpf]: yup
      .string()
      .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)
      .required(),
  });
  //
  const onSubmit = useCallback(
    (val) => {
      setFetch({
        valor: val[KEYS.cpf].replace(/\./g, "").replace(/-/g, ""),
        tipo: "cgc",
      });
    },
    [setFetch]
  );
  //
  return (
    <Stack sx={{ mt: 1 }}>
      <H6>{STR.tab2}</H6>
      <Body1 align="center">{STR.tab2Description}</Body1>
      {!data ? (
        <EntradaForm
          schema={schema}
          schemaValidator={schemaValidator}
          schemaMessageError={schemaMessageError}
          onSubmit={onSubmit}
          wait={wait}
        />
      ) : (
        <Button variant="contained" onClick={() => clearData()}>
          {STR.labelClear}
        </Button>
      )}

      {data && data.length > 0
        ? data.map((ele, idx) => (
            <Accordion key={idx}>
              <AccordionSummary expandIcon={<Icone icone="ExpandMore" />}>
                <H6
                  align="center"
                  sx={{
                    color: green[900],
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Icone icone="Discount" /> {`Voucher ${idx + 1}`}
                </H6>
              </AccordionSummary>
              <AccordionDetails>
                <CashbackInfo
                  cvSale={ele.cv_venda}
                  dataSend={ele.data_envio}
                  dataDeadLine={ele.data_prazo}
                  store={ele.loja}
                  nameClient={ele.nome_cliente}
                  status={ele.status}
                  cellPhone={ele.telefone_cliente}
                  valueVoucher={ele.valor_voucher}
                  voucher={ele.voucher}
                  seller={ele.vendedor}
                />
              </AccordionDetails>
            </Accordion>
          ))
        : null}
    </Stack>
  );
};

const CashbackInfo = ({
  cvSale,
  dataSend,
  dataDeadLine,
  store,
  nameClient,
  status,
  cellPhone,
  valueVoucher,
  voucher,
  seller,
}) => {
  const options = [
    { icon: "Discount", label: STR.cashbackInfoCvSale, value: cvSale },
    {
      icon: "CalendarToday",
      label: STR.cashbackInfoDataSend,
      value: formatarDataHora(dataSend),
    },
    {
      icon: "CalendarMonth",
      label: STR.cashbackInfoDataDeadLine,
      value: formatarData(dataDeadLine),
    },
    { icon: "Store", label: STR.cashbackInfoStore, value: store },
    { icon: "Person", label: STR.cashbackInfoNameClient, value: nameClient },
    {
      icon: getStatusCashback(status),
      label: STR.cashbackInfoStatus,
      value: getLabelStatusCashback(status),
    },
    {
      icon: "Engineering",
      label: STR.cashbackInfoSeller,
      value: seller,
    },
    {
      icon: "WhatsApp",
      label: STR.cashbackInfoCellPhone,
      value: Utilitarios.converterCelular(cellPhone),
    },
    {
      icon: "Paid",
      label: STR.cashbackInfoValueVoucher,
      value: Utilitarios.converter(valueVoucher),
    },
    {
      icon: "CardGiftcard",
      label: STR.cashbackInfoVoucher,
      value: voucher,
      permissionCopy: true,
    },
  ];

  return (
    <List dense>
      {options.map((ele, idx) => {
        if (ele.permissionCopy) {
          return (
            <ListItem key={idx}>
              <ListItemIcon>
                <Icone icone={ele.icon} />
              </ListItemIcon>
              <CopyToClipboard
                style={{ cursor: "pointer" }}
                title={STR.cashbackInfoVoucherTitle}
                text={ele.value}
                onCopy={() => {
                  toast.dark(STR.cashbackInfoVoucherCopied, {
                    type: "success",
                    toastId: "copied",
                  });
                }}
              >
                <ListItemText
                  primary={ele.label}
                  secondary={<Body1 fontWeight="bold">{ele.value}</Body1>}
                />
              </CopyToClipboard>
            </ListItem>
          );
        }

        return (
          <ListItem key={idx}>
            <ListItemIcon>
              <Icone icone={ele.icon} />
            </ListItemIcon>
            <ListItemText primary={ele.label} secondary={ele.value} />
          </ListItem>
        );
      })}
    </List>
  );
};

export default CashbackValidateSearch;
